import React, { useContext, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../state/AuthContext";
import SpeechInput from "../components/SpeechInput";

export default function LoginPage() {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const canSubmit = useMemo(
    () => email.trim().length > 3 && password.length >= 4,
    [email, password]
  );

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await login({ email, password });
      const from = location.state?.from;
      if (from) {
        navigate(from, { replace: true });
        return;
      }
      navigate("/dashboard", { replace: true });
    } catch (err) {
      setError(err?.response?.data?.message || "Invalid login.");
    } finally {
      setSubmitting(false);
    }
  };

  const bind = (name, setter) => ({
    name,
    value: name === "email" ? email : password,
    onChange: (e) => setter(e.target.value),
  });

  return (
    <div className="row justify-content-center">
      <div className="col-12 col-md-6 col-lg-5">
        <div className="card shadow-sm">
          <div className="card-body">
            <h5 className="card-title">Login</h5>
            <p className="text-muted">
              Admin and Team Members can login to manage enquiries.
            </p>
            {error ? <div className="alert alert-danger">{error}</div> : null}
            <form onSubmit={onSubmit} className="d-grid gap-3">
              <div>
                <label className="form-label">Email</label>
                <SpeechInput
                  as="input"
                  type="email"
                  placeholder="you@example.com"
                  required
                  {...bind("email", setEmail)}
                />
              </div>
              <div>
                <label className="form-label">Password</label>
                <input
                  className="form-control"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  type="password"
                  required
                />
              </div>
              <button
                className="btn btn-primary"
                type="submit"
                disabled={!canSubmit || submitting}
              >
                {submitting ? "Logging in..." : "Login"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
